import { AnchorTarget } from '../../../../../../components/blackrock/advisor-center/_types/anchor-target';
import { IconData } from '../../../../../../components/blackrock/advisor-center/_types/header';
import React, { KeyboardEvent } from 'react';

import './HeaderMenuItem.scss';

export type HeaderMenuItemProps = {
	label: string;
	icon?: IconData;
	href?: string;
	hasChild: boolean;
	target: AnchorTarget;
	ariaLabel: string;
	dataLinkEvent: string;
	titleValue: string;
	className: string;
	rel?: string;
	tabIndex?: number;
	onClick?: () => void;
	onKeydown?: (e: KeyboardEvent) => void;
	onFocus?: () => void;
	isExpanded?: boolean;
};

const HeaderMenuItem: React.FC<HeaderMenuItemProps> = ({
	className,
	onClick,
	href,
	target,
	dataLinkEvent,
	tabIndex,
	ariaLabel,
	titleValue,
	onKeydown,
	onFocus,
	icon,
	label,
	hasChild,
	isExpanded,
}) => {
	const onItemClick = () => {
		if (!href && onClick) onClick();
	};

	return (
		<div
			className={'blk-ac-header-menu-item ' + className}
			onClick={onItemClick}
		>
			<a
				data-final-url
				className="label"
				target={target}
				data-link-event={dataLinkEvent}
				{...(href && { href: href })}
				{...(isExpanded && { ['aria-controls']: 'navigation-drawer' })}
				aria-label={ariaLabel}
				title={titleValue}
				onKeyDown={onKeydown}
				onFocus={() => onFocus && onFocus()}
				tabIndex={tabIndex}
			>
				{icon?.path && (
					<img src={icon.path} alt="" className="image-item" data-final-url />
				)}
				{icon?.className && (
					<i className={`${icon.className} icon-item`}>
						{!!icon.badge && <span className="badge">{icon.badge}</span>}
					</i>
				)}
				<span dangerouslySetInnerHTML={{ __html: label }}></span>
			</a>
			{hasChild && <i className="fa fa-chevron-right icon-right" />}
		</div>
	);
};

export default HeaderMenuItem;
